@use "variables" as *;

.wrapper {
  position: absolute;
  left: calc(50% - 44px);
  top: 50vh;
  padding-top: $spacing-3;
}
